import React from "react";
import { LifeBuoy } from "lucide-react";

const MAILTO =
  "mailto:support@loompdf.com?subject=Loom%20Support%20request" +
  "&body=Hi%20Loom%20team%2C%0A%0AI%20need%20help%20with%3A%20(PDF%20%2F%20payment%20%2F%20other)%0A%0AMy%20account%20email%3A%20%0A%0ADetails%3A%20";

// Small, always-available support entry point. Rendered app-wide so it's on
// every page (incl. the fixed-height Viewer/Quiz). It's a plain mailto: link so
// it keeps working even if the backend is unavailable.
export default function SupportLink() {
  return (
    <a
      href={MAILTO}
      data-testid="global-support-link"
      title="Need help? Email support"
      className="fixed bottom-4 left-4 z-[60] inline-flex items-center gap-2 rounded-full
                 border border-stone-200 bg-white/85 backdrop-blur px-3.5 py-2 text-sm
                 font-medium text-stone-700 shadow-sm transition-colors hover:bg-white
                 hover:text-stone-900"
    >
      <LifeBuoy className="w-4 h-4" />
      <span className="hidden sm:inline">Support</span>
    </a>
  );
}
